import http from "../../services/http";
import { handleErrors } from "../../helpers/error";
import { setEditUser, setUserJumio, setUserState } from "../auth/eidtProfile";
// import { useDispatch } from "react-redux";
import storage from "../../services/storage";
import { setJumio } from "../auth/user";
import Toast from "../../Components/Toastify/Toastify";
import { setCustonmerInfo } from "../auth/approvelyInfo";

// import get from "../../services/storage";
export const getUser = ({ headers = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      //showing loader on ui
      const res = await http.get({
        url: "v1/getuser",
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          'x-store-id': (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
      dispatch(setCustonmerInfo(res?.data));  
      dispatch(setEditUser(res?.data?.data));
      dispatch(setJumio(res?.data?.jumio));
      dispatch(setUserState(res?.data?.states));

      // dispatch(setUserJumio(res.data.jumio));
      // console.log("user===>>>", res);
    } catch (error) {
      if (
        error?.response?.data?.message ===
        "Sorry! Services not available in your country."
      ) {
        storage.remove("xAuthToken");
        storage.remove("user");
        window.location.href = "/";
        Toast.error(error?.response?.data?.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const UpdateUser = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      // delete body.userAvatar
      const formData = new FormData();
      for (const key in body) {
        if (Object.hasOwnProperty.call(body, key)) {
          const value = body[key];
          formData.append(key, value);
        }
      }
      //showing loader on ui
      const res = await http.put({
        url: "v1/update_user_info",
        body: formData,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "Content-Type": "multipart/form-data",
        },
      });
      onSuccess?.(res);
      dispatch(setEditUser(res.data.data));
    } catch (error) {
      // console.log("in error=====>", error.response.message);
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
